import {register} from '@shopify/theme-sections';
import Flickity from 'flickity';
import 'flickity-imagesloaded';

export default register('featured-media', {
  onLoad() {
    this.sliderId = `#featured-media__slider--${this.id}`;
    const thisSlider = document.querySelector(`#featured-media__slider--${this.id}`);

    const settings = this.container.dataset.sliderSettings || '{}';
    const sliderSettings = JSON.parse(settings);

    // eslint-disable-next-line no-unused-vars
    const flickity = new Flickity(thisSlider, {
      // options
      freeScroll: true,
      prevNextButtons: false,
      pageDots: false,
      cellAlign: 'center',
      imagesLoaded: true,
      contain: true,
      autoPlay: sliderSettings && sliderSettings.autoplay ? 1500 : false,
    });
  },
});
